import { useEffect, useRef } from "react";

/**
 * Pre-warms the priming chat's drafts (PREC-3712) once, while the user picks
 * accounts, so that chat usually opens with them ready. Every wizard variant
 * reaches the chat — only the checkout after it is variant-dependent
 * (PREC-3719) — so the warm-up is unconditional.
 */
export const usePrewarmPriming = (prewarm: () => { unwrap: () => Promise<unknown> }): void => {
	const hasRunRef = useRef(false);

	useEffect(() => {
		if (hasRunRef.current) {
			return;
		}

		hasRunRef.current = true;

		prewarm()
			.unwrap()
			.catch((err) => console.error(err));
	}, []);
};
